module.exports = __webpack_public_path__ + "static/media/desbravador_b.1da0fbfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badges/desbravador_b.png
// module id = 1181
// module chunks = 0